/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_TrueInputs */

const en_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`true`)
};

const fr_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vrai`)
};

const de_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WAHR`)
};

const it_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VERO`)
};

const ru_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`истинный`)
};

const es_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verdadero`)
};

const zh_cn2_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真的`)
};

const ja_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`真実`)
};

const hi_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्य`)
};

const pt_pt2_common_true = /** @type {(inputs: Common_TrueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verdadeiro`)
};

/**
* | output |
* | --- |
* | "true" |
*
* @param {Common_TrueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_true = /** @type {((inputs?: Common_TrueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_TrueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_common_true(inputs)
	if (locale === "de") return de_common_true(inputs)
	if (locale === "it") return it_common_true(inputs)
	if (locale === "ru") return ru_common_true(inputs)
	if (locale === "es") return es_common_true(inputs)
	if (locale === "zh-CN") return zh_cn2_common_true(inputs)
	if (locale === "ja") return ja_common_true(inputs)
	if (locale === "hi") return hi_common_true(inputs)
	if (locale === "pt-PT") return pt_pt2_common_true(inputs)
	return en_common_true(inputs)
});